import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
//import { MEDIA_LIST } from '../../helper/listlight/listlightHelper'
import { fetchAllMediaForDetail } from "../../stores/listlight/asyncThunk";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation} from "react-router-dom";

const MediaSelectDialog: React.FC = (props) => {
  const { onClose, open, selectedMedias } = props;
  const [checked, setChecked] = React.useState([]);
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;
  const isRegister = pathname === "/pages/listlight/masters/new";
  const viewData = useSelector((state) => state.listLightMediaSelectList);
  // Similar to componentDidMount and componentDidUpdate:
  React.useEffect(() => {
    dispatch(fetchAllMediaForDetail());
    setChecked(selectedMedias);
  }, [id, dispatch, isRegister, selectedMedias]);

  const handleClose = () => {
    onClose(null);
  };

  const handleCommit = () => {
    onClose(checked);
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} scroll='paper'>
      <DialogTitle id="simple-dialog-title">媒体リスト</DialogTitle>
      <DialogContent>
        <List>
          {viewData.objList.mediaList.map((value) => {
            const labelId = `checkbox-list-label-${value}`;

            return (
              <ListItem button key={value} onClick={handleToggle(value)}>
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={checked.indexOf(value) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={value} />
              </ListItem>
            )
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          キャンセル
        </Button>
        <Button onClick={handleCommit} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MediaSelectDialog
